import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import de from './locales/de.json';

i18next.use(initReactI18next).init({
    resources: {
        en: { translation: en },
        de: { translation: de },
    },
    // Browsers set to block site data throw on access, and a throw at import
    // time would take the whole app down with it.
    lng: (() => {
        try {
            return localStorage.getItem('smartico-app-language');
        } catch (e) {
            return null;
        }
    })() || navigator.language?.slice(0, 2),
    fallbackLng: 'en',
    supportedLngs: ['en', 'de'],
    interpolation: { escapeValue: false },
});

i18next.on('languageChanged', (lng) => {
    try {
        localStorage.setItem('smartico-app-language', lng);
    } catch (e) {
        // Remembering the choice is a convenience; the switch still applies now.
    }
});

export default i18next;
